import { IntlShape } from 'react-intl';
import { createRoutingURI, getRootSlug } from '~/scripts/utils/domain';
import { EventProps } from 'ech-components/src/components/Event';

const eventService = (
  data: EventProps['data'],
  intl: IntlShape,
): EventProps['data'] => {
  return {
    __typename: data.__typename,
    node_locale: data.node_locale,
    provider: data.provider,
    title: data.title,
    location: data.location,
    plz: data.plz,
    eventDate: data.eventDate,
    href: createRoutingURI(getRootSlug(data, intl.locale)),
    moreLinkText: intl.formatMessage({
      id: 'hub.teaser.more.default',
    }),
  };
};

export default eventService;
